/**
 * Игровое время — главный ресурс. День длится 960 минут (07:00–23:00).
 * Всё, что игрок делает, стоит минут: шаг по двору, дело, переезд между зонами.
 */

export const DAY_START_MINUTE = 7 * 60; // 07:00
export const DAY_LENGTH_MINUTES = 960; // до 23:00
export const NIGHT_HOURS = 8;

/** Минуты, прошедшие с начала дня → часы:минуты на часах. */
export function formatClock(minutesIntoDay: number): string {
  const total = DAY_START_MINUTE + Math.max(0, Math.floor(minutesIntoDay));
  const h = Math.floor(total / 60) % 24;
  const m = total % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function minutesLeft(minutesIntoDay: number): number {
  return Math.max(0, DAY_LENGTH_MINUTES - minutesIntoDay);
}

export function isDayOver(minutesIntoDay: number): boolean {
  return minutesIntoDay >= DAY_LENGTH_MINUTES;
}

/**
 * Стоимость ходьбы. Диагональ по сетке дороже прямого шага —
 * путь считает это за нас, сюда приходит уже готовая длина в тайлах.
 */
export function walkMinutes(pathCost: number, opts: { vehicleFactor?: number; gearFactor?: number } = {}): number {
  const { vehicleFactor = 1, gearFactor = 1 } = opts;
  return Math.max(1, Math.round(pathCost * vehicleFactor * gearFactor));
}

/** Стоимость дела: профильный класс режет время на пятую часть. */
export function jobMinutes(baseMinutes: number, opts: { classMatch?: boolean; gearFactor?: number } = {}): number {
  const { classMatch = false, gearFactor = 1 } = opts;
  return Math.max(1, Math.round(baseMinutes * (classMatch ? 0.8 : 1) * gearFactor));
}
